export default __webpack_public_path__ + "static/media/Tennis_04.a496a107.png";